import * as React from 'react';
import { Drawer, Popover } from 'antd';
import { NiInput, NiButton } from '@component/index';
import { localizedString } from '@locale/locale';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { weightGreyColor, titleColor, lightGreyColor, lightBlackColor } from '@config/index';

function getInnerHtml(text: string) {
  return {
    __html: text
  };
}

function commentPopover({ title, value, onChange, disabled }: {
  title: string;
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}) {

  const placeholder = disabled ? 'No Comment' : localizedString('add_comment');

  const [text, setText] = React.useState<string>('');
  const [visible, setVisible] = React.useState<boolean>(false);

  React.useEffect(() => {
    setText(value || '');
  }, [value]);

  return <><Popover
    content={<div style={{ width: 500 }} dangerouslySetInnerHTML={getInnerHtml(text)}></div>}
    open={false}
  >
    <ExclamationCircleOutlined
      style={{ color: titleColor }}
      onClick={() => {
        setVisible(true);
      }}
    />
  </Popover>
    <Drawer
      open={visible}
      closable={false}
      title={title}
      width="40%"
      onClose={() => {
        setVisible(false);
      }}
      footer={[
        <NiButton
          key="cancel"
          type="ghost"
          onClick={() => {
            setVisible(false);
          }}>{localizedString('common_cancel')}</NiButton>,
        <NiButton
          key="save"
          style={{ marginLeft: 8 }}
          disabled={disabled}
          type="primary"
          onClick={() => {
            setVisible(false);
            onChange(text);
          }}
        >{localizedString('common_save')}</NiButton>
      ]}
      footerStyle={{
        display: 'flex',
        justifyContent: 'flex-end'
      }}
    >
      <NiInput.TextArea
        value={text}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(e: any) => {
          setText(e.target.value);
        }}
        rows={20}
      />
    </Drawer>
  </>;
}

export const CommentPopover = commentPopover;
